import React,{ useState, useRef, useEffect } from 'react';
import { DatePicker, ConfigProvider } from 'antd';
import { Dayjs } from 'dayjs';
import frFR from 'antd/locale/fr_FR';

import searchIcon from './../../../../assets/icons/table/search-icon.png';

import './date-picker.css';

type TableDatePickerProps = {
    onChange: (value: [Dayjs | null, Dayjs | null] | null, name: string, resetWhenValueChanges: boolean) => void;
    name: string;
    resetWhenValueChanges?: boolean;
};

export const TableDatePicker = ({onChange, name, resetWhenValueChanges = false}: TableDatePickerProps) => {
    const [visible, setVisible] = useState<boolean>(false);
    const [localValue, setLocalValue] = useState<[Dayjs | null, Dayjs | null] | null>(null);
    const [value, setValue] = useState<[Dayjs | null, Dayjs | null] | null>(null);
    const { RangePicker } = DatePicker;
    const fakeInputRef = useRef<HTMLDivElement>(null);
    const pickerPopupRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            const target = event.target as HTMLElement | null;

            if (
                fakeInputRef.current && !fakeInputRef.current.contains(target) &&
        pickerPopupRef.current && !pickerPopupRef.current.contains(target) &&
        target?.closest('.ant-picker-dropdown') === null
            ) {
                setVisible(false);
            }
        };

        document.addEventListener('click', handleClickOutside);

        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, []);

    const handleChange = (dates: [Dayjs | null, Dayjs | null] | null) => {
        setVisible(false);

        if (!dates || !dates[0] || !dates[1]) {
            setLocalValue(null);
            setValue(null);
            onChange([null, null], name, true);

            return;
        }

        const validDates: [Dayjs, Dayjs] = [dates[0], dates[1]];
        setLocalValue(validDates);
        setValue(validDates);
        onChange(validDates, name, true);
    };

    useEffect(() => {
        if (resetWhenValueChanges) {
            setLocalValue(null);
            setValue(null);
        }
    }, [resetWhenValueChanges]);

    return (
        <div className='relative h-6 px-1 table-datepicker'>
            <div className={`${visible && 'background-gradient'} rounded-md h-full w-full cursor-pointer`}>
                <div
                    ref={fakeInputRef}
                    onClick={() => setVisible(true)}
                    className='flex items-center justify-end h-full pr-2 bg-white rounded-[4px]'
                >
                    <div className='flex flex-col self-center items-center w-full text-[8px]'>
                        {localValue ? (
                            <>
                                <p className='leading-[1.1]'>{localValue[0]?.format('DD/MM/YYYY')}</p>
                                <p className='leading-[1.1]'>{localValue[1]?.format('DD/MM/YYYY')}</p>
                            </>
                        ) : null}
                    </div>
                    <img className='w-2.5 h-2.5' src={searchIcon} alt="search"/>
                </div>
            </div>
            
            <div
                ref={pickerPopupRef}
                style={{display: visible ? 'block' : 'none'}}
                className='absolute z-[999999] p-[2px] rounded-md range-picker-popup background-gradient'
            >
                <ConfigProvider locale={frFR}>
                    <RangePicker value={value} format="DD/MM/YYYY" onChange={handleChange}/>
                </ConfigProvider>
            </div>
            
        </div>
    );
};